import type { Billing, InvoiceHolder } from '@optionway/models';
import { modelsImpl } from '@optionway/models';

interface BillingStore {
  billing: Billing;
  buyerIsMainPassenger: boolean;
}

// Billing is the invoice holder — a title, a name, an address. The GDS customer is built by the BFF from
// the main passenger, never from here.
export const useBillingStore = defineStore('billing', {
  state: (): BillingStore => {
    const billing = new modelsImpl.BillingImpl();
    billing.info = blankInvoiceHolder();
    return { billing, buyerIsMainPassenger: true };
  },
  actions: {
    prefillFromMainPassenger() {
      const passenger = usePassengersStore().mainPassenger;
      if (!passenger) {
        return;
      }
      this.billing.info.title = passenger.title;
      this.billing.info.firstName = passenger.firstName;
      this.billing.info.lastName = passenger.lastName;
    },
    setBuyerIsMainPassenger(checked: boolean) {
      this.buyerIsMainPassenger = checked;
      if (checked) {
        this.prefillFromMainPassenger();
        return;
      }
      this.billing.info = blankInvoiceHolder();
    },
    // The buyer typed a name of their own: the switch goes off without touching what was typed.
    markBuyerIdentityEdited() {
      this.buyerIsMainPassenger = false;
    },
  },
});

// InvoiceHolder is a type, so it has no Impl: its blank borrows the passenger's typed empty fields.
function blankInvoiceHolder(): InvoiceHolder {
  const { title, firstName, lastName } = new modelsImpl.PassengerImpl();
  return { title, firstName, lastName };
}
